/* eslint-disable react/no-danger, max-len */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

import Cta from 'components/Core/Cta';
import IconSvg from 'components/Core/IconSvg';

import { AppContext } from 'context/AppContext';
import trackAction, { setSqzlCookieConsent } from 'utils/tracking';

import CookieModal from './CookieModal';
import { CookieText as CookieTextElem } from './CookieBar.styles';

const CookieBar = ({ title, text, ctaTitle, showOptions, toggleModal, ...rest }) => {
  const { showCookieModal, updateAppState, hideCookieBar = Cookies.get('sfnAcceptEssential') } = useContext(
    AppContext,
  );

  const acceptAll = () => {
    updateAppState({ hideCookieBar: true });
    // GTM Event
    trackAction('cookies', ctaTitle, 'click');
    // set cookie
    Cookies.set('sfnAcceptEssential', true);
    Cookies.set('sfnAcceptAnalytics', true);
    Cookies.set('sfnAcceptThirdParty', true);
    // sqzl event
    setSqzlCookieConsent();
  };

  const openModal = () => {
    // GTM Event
    trackAction('cookies', showOptions, 'click');
    toggleModal();
  };

  return (
    <>
      {!hideCookieBar && (
        <div className="bg-white py-4 lg:py-8 w-full fixed z-100 bottom-0 left-0 right-0 border-t-2 border-basic-200 rounded-t-base md:rounded-t-none">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-between -mx-4 h-screen-60 md:h-auto">
              <div className="flex-full max-w-full md:flex-2/3 md:max-w-2/3 lg:flex-3/4 lg:max-w-3/4 px-4">
                <h5>{title}</h5>
                <CookieTextElem dangerouslySetInnerHTML={{ __html: text }} />
              </div>
              <div className="flex-full max-w-full md:flex-1/3 md:max-w-1/3 lg:flex-1/4 lg:max-w-1/4 px-4 mt-auto flex flex-col justify-center md:mt-0 items-center">
                <Cta showIcon={false} onClick={acceptAll} className="w-full">
                  {ctaTitle}
                </Cta>
                <button type="button" className="font-bold mt-4 flex items-center group" onClick={openModal}>
                  <IconSvg
                    icon="arrow-right"
                    size={10}
                    className="text-primary mr-2 group-hover:mr-0 transition-spacing duration-150"
                  />
                  {showOptions}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showCookieModal && <CookieModal {...rest} />}
    </>
  );
};

CookieBar.propTypes = {
  title: PropTypes.string,
  text: PropTypes.node,
  ctaTitle: PropTypes.string,
  showOptions: PropTypes.string,
  toggleModal: PropTypes.func,
};

CookieBar.defaultProps = {
  title: 'Cookies',
  text: `<p>Wij gebruiken cookies om uw gebruikservaring te optimaliseren, het webverkeer te analyseren en gerichte
    advertenties te kunnen tonen via derde partijen. Lees meer over hoe wij cookies gebruiken in de cookie
    policy. U kunt de cookies beheren door op "Voorkeuren" te klikken.</p>`,
  ctaTitle: 'Accepteren',
  showOptions: 'Voorkeuren instellen',
  toggleModal: () => {},
};

export default CookieBar;
